import { render, staticRenderFns } from "./EditMediaModal.vue?vue&type=template&id=64846818&scoped=true&"
import script from "./EditMediaModal.vue?vue&type=script&lang=js&"
export * from "./EditMediaModal.vue?vue&type=script&lang=js&"
import style0 from "./EditMediaModal.vue?vue&type=style&index=0&id=64846818&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64846818",
  null
  
)

export default component.exports
import {QCard,QBtn,QCarousel,QCarouselSlide,QVideo,QImg,QTooltip,QCardSection,QInput,QCardActions,ClosePopup} from 'quasar'
component.options.components = Object.assign(Object.create(component.options.components || null), component.options.components || {}, {QCard,QBtn,QCarousel,QCarouselSlide,QVideo,QImg,QTooltip,QCardSection,QInput,QCardActions})
component.options.directives = Object.assign(Object.create(component.options.directives || null), component.options.directives || {}, {ClosePopup})
